module.exports = __webpack_public_path__ + "static/media/footer-icon-dark-3.11b56868.svg";